<template>
    <div class="wrapper">
        <div :class="['stepper', bannerClass]">
            <mds-stepper v-if="steps.length > 0" v-model="steps" size="small" :responsive="responsive" @mds-step-clicked="handleStepClicked"></mds-stepper>
        </div>
        <router-view></router-view>
    </div>
</template>
<script>
import MdsStepper from "@mds/stepper";
import cloneDeep from "lodash.clonedeep";

export default {
    name: "workflow",
    components: {
        MdsStepper
    },
    data() {
        return {
            steps: [],
            responsive: false
        };
    },
    created() {
        this.steps = cloneDeep(this.$store.getters["stepper/getCurrentFlow"]);
        this.setActive(this.$route.path);
    },
    mounted() {
        this.resizeHandler();
        window.addEventListener("resize", this.resizeHandler, false);
    },
    computed: {
        bannerClass() {
            return this.$store.getters["stepper/getPortfolioWarningClass"];
        }
    },
    methods: {
        setActive(path) {
            this.steps.forEach(item => {
                this.$set(item, "active", item.path === path);
                if (item.steps) {
                    item.steps.forEach(subStep => {
                        this.$set(subStep, "active", subStep.path === path);
                        if (subStep.active) {
                            this.$set(item, "active", true);
                        }
                    });
                }
            });
            if (this.steps.length > 0) {
                this.$store.commit("stepper/SET_CURRENT_STEP", path);
            }
        },
        handleStepClicked(step) {
            this.$store.dispatch("stepper/setPortfolioWarningClass", false);
            const flowMap = this.$store.getters["stepper/getFlowMap"];
            if (flowMap[step.path]) {
                this.$router.push(flowMap[step.path]);
            }
        },
        resizeHandler() {
            const viewportWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
            this.responsive = viewportWidth <= 600;
        }
    },
    watch: {
        $route: {
            immediate: true,
            handler(newVal) {
                const { path } = newVal;
                this.setActive(path);
            }
        }
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.resizeHandler, false);
    }
};
</script>
<style scoped lang="scss">
.wrapper {
    height: 100%;
    position: relative;
    z-index: 1;
}
.stepper {
    position: absolute;
    width: 40%;
    margin-left: -20.5%;
    right: 29.5%;
    top: 0;
    z-index: 10;
    &.with-banner {
        top: 45px;
    }
}
</style>
